// routes/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { useEffect } from "react";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user } = useAuth();

  useEffect(() => {
    // Not logged in
    if (!user) {
      toast.error("Please login to access this page");
    }
    // Logged in but role not allowed
    if (user && allowedRoles && !allowedRoles.includes(user.role)) {
      toast.error("Your role does not have permission to access this page", {
        position: "top-center",
      });
    }
  }, [user, allowedRoles]);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ProtectedRoute;
